import {
    FETCH_TIMESHEET,
    FETCH_ALL_TIMESHEETS,
    ADD_TIMESHEET,
    UPDATE_TIMESHEET,
    REMOVE_ATTACHMENT,
    FETCH_ATTACHMENTS,
    UPLOAD_TIMESHEET,
    APPROVE_TIMESHEET,
    DEFAULTERS_REPORTS,
    SUMMARY_REPORTS,
    TASK_REPORTS,
    GET_ALL_PROJECTS,
    GET_ACTIVE_PROJECT,
    SUMMARY_BY_DAY_REPORTS,
} from "../actionTypes";

const defaultState = {
    all: [],
    byDay: [],
    currentTimesheet: {},
    attachments: [],
    defaulters: [],
    allProjects: [],
    activeProjects:[],
    taskList:[]
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FETCH_ALL_TIMESHEETS:
            return { ...state, all: action.payload || [] };
        case FETCH_TIMESHEET:
            return { ...state, currentTimesheet: action.payload || [] };
        case GET_ACTIVE_PROJECT:
                return { ...state, activeProjects: action.payload || [] };     
        case ADD_TIMESHEET:
            return {
                ...state,
                all: [...state.all, action.payload],
                currentTimesheet: action.payload || [],
            };
        case UPDATE_TIMESHEET:
            return { ...state, currentTimesheet: action.payload || [] };
        case REMOVE_ATTACHMENT:
            return { ...state, currentTimesheet: action.payload || [] };
        case FETCH_ATTACHMENTS:
            return { ...state, attachments: action.payload || [] };
        case UPLOAD_TIMESHEET:
            return { ...state, currentTimesheet: action.payload || [] };
        case APPROVE_TIMESHEET:
            return { ...state, currentTimesheet: action.payload };
        case DEFAULTERS_REPORTS:
            return { ...state, defaulters: action.payload };
        case SUMMARY_REPORTS:
            return { ...state, all: action.payload || [] };
        case TASK_REPORTS:
            return {...state, taskList: action.payload || []};
        case SUMMARY_BY_DAY_REPORTS:
            return { ...state, byDay: action.payload || [] };
        case GET_ALL_PROJECTS:
            return { ...state, allProjects: action.payload || [] };
        default:
            return state;
    }
};
